"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _require = require("../utils"),
  serializeError = _require.serializeError;
var NewRelicPresenter = /*#__PURE__*/function () {
  function NewRelicPresenter() {
    (0, _classCallCheck2["default"])(this, NewRelicPresenter);
  }
  return (0, _createClass2["default"])(NewRelicPresenter, [{
    key: "distillPayloads",
    value: function distillPayloads() {
      var _payloads = [];
      for (var _len = arguments.length, payloads = new Array(_len), _key = 0; _key < _len; _key++) {
        payloads[_key] = arguments[_key];
      }
      payloads.forEach(function (payload) {
        var _payload$response, _payload$config, _payload$response2;
        _payloads.push(payload !== null && payload !== void 0 && payload.isAxiosError ? {
          data: payload === null || payload === void 0 || (_payload$response = payload.response) === null || _payload$response === void 0 ? void 0 : _payload$response.data,
          url: payload === null || payload === void 0 || (_payload$config = payload.config) === null || _payload$config === void 0 ? void 0 : _payload$config.url,
          status: payload === null || payload === void 0 || (_payload$response2 = payload.response) === null || _payload$response2 === void 0 ? void 0 : _payload$response2.status,
          message: payload === null || payload === void 0 ? void 0 : payload.message
        } : payload instanceof Error ? serializeError(payload, true) : payload);
      });
      return _payloads;
    }
  }]);
}();
var instance = new NewRelicPresenter();
module.exports = exports = instance;